<template>
  <b-modal :ref="ref_id" hide-footer hide-header size="lg">
    <div class="flight-pad-details-modal">
      <header class="flight-pad-details-modal__header">
        <span class="h5 bold m-0 ml-auto">Dettaglio del viaggio</span>
        <b-button variant="ghost" class="close ml-auto" @click="() => hide_modal()">
          &#x2715;
        </b-button>
      </header>
      <main class="flight-pad-details-modal__main">
        <flight-pad-details :flight_offer="flight_offer" show_dates />
      </main>
      <footer v-if="selectable" class="flight-pad-details-modal__footer">
        <div>
          <!-- empty -->
        </div>
        <flight-pad-price-button :flight_offer="flight_offer" direction="horizontal" />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import FlightPadDetails from '@/components/blocks/flight-pad/flight-pad-details/flight-pad-details.vue';
import FlightPadPriceButton from '@/components/blocks/flight-pad/flight-pad-price-button.vue';

export default {
  name: 'flight-pad-details-modal',
  components: {
    'flight-pad-details': FlightPadDetails,
    'flight-pad-price-button': FlightPadPriceButton,
  },
  props: {
    wrapper_id: String,
    flight_offer: Object,
    selectable: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ref_id() {
      return `internal:${this.wrapper_id}`;
    },
  },
  methods: {
    show_modal() {
      try {
        this.$refs[this.ref_id].show();
      } catch (e) {
        this.log('flight-pad-details-modal.show_modal');
        this.log(e);
      }
    },
    hide_modal() {
      try {
        this.$refs[this.ref_id].hide();
      } catch (e) {
        this.log('flight-pad-details-modal.hide_modal');
        this.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-details-modal {
  padding: 15px;
  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    padding-bottom: 20px;
  }
  &__main {
    border-top: 1px solid $light-gray;
  }
  &__footer {
    padding-top: 15px;
    border-top: 1px solid $light-gray;
    display: flex;
    justify-content: flex-end;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }

  .close:hover {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
  }
  .close:focus {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
  }
  .close:active {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
  }
}
</style>
